import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Loading } from "@/components/Loading";
import { useAuthLayout } from "@/routes/layouts/AuthLayout/AuthLayout.hooks";
import { SessionErrorPage } from "@/pages/SessionError/SessionError";

export const AuthLayout: FC = () => {
  const { auth, apiClient, logout } = useAuthLayout();

  switch (auth.type) {
    case "NotLogin":
      return <SessionErrorPage errorType={"not_login"} />;
    case "Forbidden":
      return <SessionErrorPage errorType={"forbidden"} />;
    case "Loading":
      return <Loading />;
    case "LoggedIn":
      return <Outlet context={{ user: auth.user, apiClient: apiClient, logout }} />;
  }
};
